import React from "react";
import { featuresData } from "../../constants/home";
import FeatureCard from "../../components/FeatureCard";

const FeaturesSection = () => {
  return (
    <div className="md:bg-gradientbg bg-gradient-m-bg bg-cover bg-center bg-no-repeat py-[40px] md:py-[66px] ">
      <div className="container relative z-10 flex flex-col gap-8 px-4">
        <div className="text-left font-inter md:text-left text-[24px] sm:text-[26px] md:text-[36px] font-bold text-cf-white leading-snug">
          Smooth Onboarding,
          <br className="md:block" />
          Seamless Payments, Instant Payouts
        </div>

        <div className="flex flex-wrap justify-center md:justify-start gap-8">
          {featuresData?.map((data) => (
            <div className="w-full md:w-[30%] flex-shrink-0 relative">
              <FeatureCard featureData={data} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;
